<template>
	<el-date-picker
		style="width: 100%"
		v-model="date_range"
		:picker-options="pickerOptions"
		type="daterange"
		range-separator="~"
		unlink-panels
		start-placeholder="开始日期"
		end-placeholder="结束日期"
		value-format="yyyy-MM-dd"
	>
	</el-date-picker>
</template>

<script>
export default {
	name: "l-el-date-range",
	props: {
		value: {
			type: Array,
		},
	},
	data() {
		return {
			date_range: [],
			//日期范围快捷选择
			pickerOptions: {
				shortcuts: [
					{
						text: "今 日",
						onClick(picker) {
							picker.$emit("pick", [new Date(), new Date()]);
						},
					},
					{
						text: "昨 日",
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setDate(start.getDate() - 1);
							picker.$emit("pick", [start, end]);
						},
					},
					{
						text: "本 周",
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							const day = start.getDay() || 7;
							const date = start.getDate();
							start.setDate(date - (day - 1));
							picker.$emit("pick", [start, end]);
						},
					},
					{
						text: "本 月",
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setDate(1);
							picker.$emit("pick", [start, end]);
						},
					},
				],
			},
		};
	},

	watch: {
		value(val) {
			this.date_range = val;
		},
		date_range(val) {
			this.$emit("input", val);
		},
	},
};
</script>
